import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    marginTop: 16,
    width: '100%',
    maxWidth: theme.space.basicDataMaxWidth,
    margin: '0 auto',
  },
  paymentItem: {
    flex: 1,
    display: 'flex',
    flexDirection:'column',
    alignItems: 'flex-start',
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
    },
  },
  paymentItemButton: {
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      top: -3,
    },
  },
  paymentItemTitle: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexBasis: '100%',
    },
  },
  paymentItemSeparator: {
    width: '1px',
    height: '100%',
    background: theme.color.greys[15],
    marginLeft: 10,
    marginRight: 10,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '1px',
      margin: '10px 0',
    },
  },
  paymentCard: {
    padding: 16,
    display: 'flex',
    alignItems: 'stretch',
    minWidth: 470,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      minWidth: 'unset',
    },
  },
  headerWrapper: {
    marginTop: 16,
    display: 'flex',
    gap: 77,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 24,
    },
  },
  currency: {
    color: theme.color.oranges[50],
  },
  headerContainer: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      padding: '0 16px',
      flexDirection: 'column',
    },
  },
  headerTitle: {
    padding: 0,
    '& h1, p': {
      textAlign: 'left',
    },
  },
  paymentWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  paymentContainer: {
    maxWidth: 475,
    background: theme.color.greys[20],
    padding: 0,
    margin: '58px 0 24px 0',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'unset',
      padding: 0,
      margin: '16px 0',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  sortPanelWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 24,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 16,
    },
  },
  sortPanel: {
    margin: 0,
  },
  howWeCalculated: {
    flex: '0 0 auto',
  },
  selectRecommendedAllButton: {
    display: 'flex',
    justifyContent: 'center',
    margin: '24px auto 120px auto',
  },
  paymentItemCurrency: {
    marginBottom: 4,
  }
}), { name: 'SelectRecommendedFunds' });
